import React, { useEffect, useState } from "react";
import { Clock, Flame } from "lucide-react";

function fmt(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h >= 1) return `${h}h ${String(m).padStart(2, "0")}m`;
  if (m >= 1) return `${m}m ${String(sec).padStart(2, "0")}s`;
  return `${sec}s`;
}

// Live, pulsing countdown shown ONLY for non-recurring offers that expire today.
export default function UrgencyCountdown({ expiresAt, recurring, variant = "card" }) {
  const [now, setNow] = useState(Date.now());
  const end = expiresAt ? new Date(expiresAt).getTime() : 0;
  const endsToday = expiresAt && new Date(expiresAt).toDateString() === new Date().toDateString();
  const urgent = !recurring && endsToday && end > now;

  useEffect(() => {
    if (!urgent) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [urgent]);

  if (!urgent) return null;
  const label = fmt(end - now);

  const Dot = ({ size }) => (
    <span className={`relative flex ${size}`}>
      <span className={`animate-ping absolute inline-flex h-full w-full rounded-full bg-white/70`} />
      <span className={`relative inline-flex rounded-full ${size} bg-white`} />
    </span>
  );

  if (variant === "detail") {
    return (
      <div data-testid="urgency-countdown"
        className="flex items-center gap-2 p-3 rounded-xl bg-[#E63946] text-white text-sm font-extrabold shadow-sm kn-pop">
        <Dot size="h-2.5 w-2.5" />
        <Flame className="h-4 w-4" /> Affrettati! Scade tra {label}
      </div>
    );
  }

  return (
    <span data-testid="urgency-countdown"
      className="inline-flex items-center gap-1 text-[11px] font-extrabold px-2 py-0.5 rounded-full bg-[#E63946] text-white shadow-sm">
      <Dot size="h-1.5 w-1.5" />
      <Clock className="h-3 w-3" /> Scade tra {label}
    </span>
  );
}
